import { useEffect, useState } from "react";
import api from "../../lib/api";
import { ExternalLink, MapPin } from "lucide-react";

export default function ContentTab() {
  const [data, setData] = useState({ unlocked: false, items: [] });
  useEffect(() => { api.get("/partner-portal/content-links").then(({data}) => setData(data)).catch(()=>{}); }, []);
  if (!data.unlocked) return (
    <div className="aii-card p-8 text-center" data-testid="partner-content-locked">
      <MapPin size={28} className="mx-auto text-[color:var(--aii-muted)] mb-2 opacity-50"/>
      <div className="text-sm text-[color:var(--aii-text-2)]">{data.reason || "Content feed will unlock once your first participant is approved."}</div>
    </div>
  );
  return (
    <div className="space-y-3" data-testid="partner-content-feed">
      <p className="text-sm text-[color:var(--aii-text-2)]">Social media posts curated by our SMCM — perfect for sharing back with your candidates and community.</p>
      {data.items.length === 0 && <div className="aii-card p-8 text-center text-sm text-[color:var(--aii-muted)]">No published posts yet.</div>}
      {data.items.map(c => (
        <div key={c.id} className="aii-card p-4 flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-widest text-brand font-bold">{c.platform}</div>
            <div className="font-semibold">{c.title}</div>
            {c.caption && <div className="text-xs text-[color:var(--aii-text-2)] mt-0.5 line-clamp-3">{c.caption}</div>}
            <div className="text-[11px] text-[color:var(--aii-muted)] mt-1">Scheduled: {c.scheduled_date}</div>
          </div>
          {c.media_url && <a href={c.media_url} target="_blank" rel="noopener noreferrer" data-testid={`partner-content-open-${c.id}`} className="text-xs px-3 py-1.5 border border-brand text-brand rounded-md hover:bg-[color:var(--aii-green-tint)] flex items-center gap-1 flex-shrink-0"><ExternalLink size={11}/> {c.kind === "participant_media" ? "View / Download" : "Open"}</a>}
        </div>
      ))}
    </div>
  );
}
